export default "__VITE_ASSET__COpzzNJu__"